/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Author from 'ui/src/components/Author';
import Image from 'next/image';

type CardAuthorProps = {
  imageUrl: string;
  name: string;
  withAuthorAvatar?: boolean;
};

function CardAuthor({ imageUrl, name, withAuthorAvatar = true }: CardAuthorProps) {
  return (
    <span>
      <Author align="center" classes="gap-1">
        {withAuthorAvatar && (
          <Author.Image>
            <Image
              src={imageUrl}
              width={58}
              height={58}
              alt=""
              className="rounded-full object-cover"
              unoptimized
            />
          </Author.Image>
        )}
        <Author.Name>{name}</Author.Name>
      </Author>
    </span>
  );
}

export default CardAuthor;
